export const aboutUs = [
  {
    id: 1,
    title: "تقنيات متقدمة تناسب البيئة الصحراوية",
    contentText:
      "نستخدم أحدث تقنيات التبريد المصممة خصيصًا لتحمّل الأجواء الصحراوية القاسية، مع نظام تبريد فعّال وتنقية عالية للهواء من الغبار والشوائب. أداء قوي وراحة تدوم.",
    image: require("../../assets/about-us-contnet-1.png"),
  },
  {
    id: 2,
    title: "كفاءة طاقة وتوفير في التكاليف",
    contentText:
      "تكييفاتنا مصممة لتوفير الطاقة دون المساس بالأداء. استمتع بدرجات حرارة مثالية بأقل استهلاك ممكن، لتوفر على فواتيرك وتبقى مرتاحًا في كل الأوقات.",
    image: require("../../assets/about-us-content-2.png"),
  },
  {
    id: 3,
    title: "جودة تصنيع ومواد مضمونة",
    contentText:
      "نعتمد على خامات عالية الجودة وتقنيات تصنيع متقدمة لضمان الأداء والاستمرارية. تكييفاتنا تتحمّل الظروف الصعبة وتبقى موثوقة لأطول فترة ممكنة.",
    image: require("../../assets/about-us-content-3.png"),
  },
  {
    id: 4,
    title: "خدمة ما بعد البيع والصيانة",
    contentText:
      "نرافقك بعد التركيب بخدمة صيانة احترافية وسريعة. راحة بالك مستمرة معنا، فدعمنا لا يتوقف عند البيع — بل يبدأ بعده.",
    image: require("../../assets/about-us-content-4.png"),
  },
];
